

//      mobile menu

const hamburgerMenu = document.querySelector(".hamburger-menu");
const mobMenu = document.querySelector(".mob-menu");
const body = document.body;

const toogleMobmenu = () => {
  mobMenu.classList.toggle("active");
  hamburgerMenu.classList.toggle("active");
  body.classList.toggle("overflow");
};

const closeMobMenu = () => {
  mobMenu.classList.remove("active");
  hamburgerMenu.classList.remove("active");
  body.classList.remove("overflow");
};

hamburgerMenu.addEventListener("click", toogleMobmenu);

//scroll-to

const anchors = document.querySelectorAll('a.mob-menu__link');

for (let anchor of anchors) {
  anchor.addEventListener('click', (e) => {
    closeMobMenu();
  });
};

// if (location.hash) {
//   setTimeout(() => {
//     const actualHash = location.hash;
//     document.getElementById(actualHash).scrollIntoView({
//       behavior: 'smooth',
//       block: 'center'
//     });
//     history.replaceState(null, null, ' ');
//   }, 500);
//   clearTimeout();
// }

//      drop-down

const dropDownHeader = document.querySelector(".drop-down__header");
const dropDownList = document.querySelector(".drop-down__list");
const dropDownArrow = document.querySelector(".drop-down__icon");

const openDropDown = () => {
  dropDownList.classList.toggle("active");
  dropDownArrow.classList.toggle("active");
  dropDownHeader.classList.toggle("active");
};

const closeDropDown = () => {
  dropDownList.classList.remove("active");
  dropDownArrow.classList.remove("active");
  dropDownHeader.classList.remove("active");
};

dropDownHeader.addEventListener("click", (e) => {
  e.stopPropagation();
  openDropDown();
});

document.addEventListener('click', (e) => {
  let target = e.target;
  if (target !== dropDownHeader) {
    closeDropDown();
  }
});

//form 

const forms = document.querySelectorAll(".form");
const input = document.querySelectorAll(".input");
const modal = document.querySelectorAll(".popup");
const closeModalBtn = document.querySelectorAll(".close-btn");

const submitForm = (e) => {
  e.preventDefault();
  if (typeof AppescoCfg === 'undefined') {
    return form.reset();
  }

  const AppescoDomain = AppescoCfg.domain || '';
  const AppescoTenant = AppescoCfg.tenant || '';
  if (!AppescoDomain || !AppescoTenant) {
    return form.reset();
  }

  const form = e.target;
  const formData = new FormData(form);
  const data = Object.fromEntries(formData);
  const postUrl = `https://${AppescoDomain}/api/tenant/${AppescoTenant}/crm/leads/public`;
  postJSONForm({ data: data }, postUrl, function (response, err) {
    if (!err) {
      modal.forEach((md) => md.classList.add("popup_active"));
    }
  });
  form.reset();
}

function postJSONForm(data, theUrl, cb) {
  var xmlhttp = new XMLHttpRequest();
  xmlhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      // Typical action to be performed when the document is ready:
      if (cb) {
        cb(xmlhttp.responseText, null);
      }
    }
  };
  xmlhttp.open("POST", theUrl);
  xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  xmlhttp.send(JSON.stringify(data));
}

forms.forEach((form) => {
  form.addEventListener("submit", submitForm);
});

closeModalBtn.forEach(
  (element) =>
  (element.onclick = () => modal.forEach((md) => md.classList.remove("popup_active"))
  ));

